var _div;
import { memo } from 'react';
import WiFiOff from '@crehana/icons/fill/WiFiOff';
import cn from 'clsx';
import { usePlayroomAchievementsTranslations } from "../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ErrorViewOnAchievements = function ErrorViewOnAchievements() {
  var _usePlayroomAchieveme = usePlayroomAchievementsTranslations(),
    t = _usePlayroomAchieveme.t;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-rounded-1 tw-h-28 tw-text-center',
    // Border
    'tw-border tw-border-solid tw-border-alert-400',
    // Display
    'tw-flex tw-flex-col tw-justify-center tw-items-center'),
    children: [_div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-rounded-full tw-w-6.4 tw-h-6.4 tw-mb-2.4 tw-flex tw-justify-center tw-items-center tw-bg-alert-100",
      children: /*#__PURE__*/_jsx(WiFiOff, {
        size: 32,
        ignoreColor: true,
        className: "tw-fill-current tw-text-alert-400 tw-w-3.2"
      })
    })), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h4", {
        className: "tw-font-subtitle4 tw-text-neutral-light-800 dark:tw-text-neutral-light-100 tw-mb-0.8",
        children: t('PAS_ERROR_VIEW_TITLE')
      }), /*#__PURE__*/_jsx("p", {
        className: "tw-font-body4 tw-text-neutral-light-700 dark:tw-text-neutral-light-100",
        children: t('PAS_ERROR_VIEW_DESCRIPTION')
      })]
    })]
  });
};
export default /*#__PURE__*/memo(ErrorViewOnAchievements);